import logo from "../../../../public/projects/Rustomjee/logo/logo.png";
import bay180 from "../../../../public/projects/Rustomjee/projects/180Bay.jpg";
import panorama from "../../../../public/projects/Rustomjee/projects/Panorama.jpg";
import Parishram from "../../../../public/projects/Rustomjee/projects/Parishram.jpg";

//parishram
import overviewImage_parishram from "../../../../public/projects/Rustomjee/images/parishram/Overview/1.webp";
import bannerDesktopImage_parishram from "../../../../public/projects/Rustomjee/images/parishram/Banner/1.webp";
import bannerMobileImage_parishram from "../../../../public/projects/Rustomjee/images/parishram/Banner/2.webp";
import siteVisitBannerImage_parishram from "../../../../public/projects/Rustomjee/images/parishram/SiteVisitBanner/1.webp";
import Location_parishram from "../../../../public/projects/Rustomjee/images/parishram/Location/L1.webp";
import Hightlights_parishram from "../../../../public/projects/Rustomjee/images/parishram/Highlights/1.webp";
import image1BHK_parishram from "../../../../public/projects/Rustomjee/images/parishram/floorplan/1.webp";
import image2BHK_parishram from "../../../../public/projects/Rustomjee/images/parishram/floorplan/2.webp";
import image3BHK_parishram from "../../../../public/projects/Rustomjee/images/parishram/floorplan/3.webp";
import location_parishram from "../../../../public/projects/Rustomjee/images/parishram/Overview/l.png";
import cal_parishram from "../../../../public/projects/Rustomjee/images/parishram/Overview/c.png";
import newlaunch_parishram from "../../../../public/projects/Rustomjee/images/parishram/Overview/n.png";
import g1_parishram from "../../../../public/projects/Rustomjee/images/parishram/Gallery/1.webp";
import g2_parishram from "../../../../public/projects/Rustomjee/images/parishram/Gallery/2.webp";
import g3_parishram from "../../../../public/projects/Rustomjee/images/parishram/Gallery/3.webp";
import g4_parishram from "../../../../public/projects/Rustomjee/images/parishram/Gallery/4.webp";
import g5_parishram from "../../../../public/projects/Rustomjee/images/parishram/Gallery/5.webp";

//thepanorama
import overviewImage_panorama from "../../../../public/projects/Rustomjee/images/panorama/Overview/1.webp";
import bannerDesktopImage_panorama from "../../../../public/projects/Rustomjee/images/panorama/Banner/1.webp";
import bannerMobileImage_panorama from "../../../../public/projects/Rustomjee/images/panorama/Banner/2.webp";
import siteVisitBannerImage_panorama from "../../../../public/projects/Rustomjee/images/panorama/SiteVisitBanner/1.webp";
import Location_panorama from "../../../../public/projects/Rustomjee/images/panorama/Location/L1.webp";
import Hightlights_panorama from "../../../../public/projects/Rustomjee/images/panorama/Highlights/1.webp";
import image1BHK_panorama from "../../../../public/projects/Rustomjee/images/panorama/floorplan/1.webp";
import image2BHK_panorama from "../../../../public/projects/Rustomjee/images/panorama/floorplan/2.webp";

import location_panorama from "../../../../public/projects/Rustomjee/images/panorama/Overview/l.png";
import cal_panorama from "../../../../public/projects/Rustomjee/images/panorama/Overview/c.png";
import newlaunch_panorama from "../../../../public/projects/Rustomjee/images/panorama/Overview/n.png";
import g1_panorama from "../../../../public/projects/Rustomjee/images/panorama/Gallery/1.webp";
import g2_panorama from "../../../../public/projects/Rustomjee/images/panorama/Gallery/2.webp";
import g3_panorama from "../../../../public/projects/Rustomjee/images/panorama/Gallery/3.webp";
import g4_panorama from "../../../../public/projects/Rustomjee/images/panorama/Gallery/4.webp";
import g5_panorama from "../../../../public/projects/Rustomjee/images/panorama/Gallery/5.webp";

//bayview
import overviewImage_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Overview/1.webp";
import bannerDesktopImage_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Banner/1.webp";
import bannerMobileImage_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Banner/2.webp";
import siteVisitBannerImage_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/SiteVisitBanner/1.webp";
import Location_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Location/L1.webp";
import Hightlights_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Highlights/1.webp";
import image1BHK_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/floorplan/1.webp";
import image2BHK_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/floorplan/2.webp";
import image3BHK_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/floorplan/3.webp";

import location_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Overview/l.png";
import cal_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Overview/c.png";
import newlaunch_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Overview/n.png";
import g1_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Gallery/1.webp";
import g2_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Gallery/2.webp";
import g3_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Gallery/3.webp";
import g4_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Gallery/4.webp";
import g5_180bayview from "../../../../public/projects/Rustomjee/images/180bayview/Gallery/5.webp";

export const developersRustomjee = {
  name: `Rustomjee Properties in Mumbai`,
  properties: [
    {
      name: "Rustomjee - Parishram ",
      image: Parishram,
      price: "On Request",
      location: "Pali Hill, Bandra, Mumbai",
      bed: "1 - 3 BHK",
      state: "Mumbai",
      developer: "Rustomjee",
      size: "1564 Sq. Ft. ",
      url: `/rustomjee-parishram-pali-hill-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Rustomjee - The Panorama",
      image: panorama,
      price: "On Request",
      location: "Mumbai",
      projectlocation: "Pali Hill, Bandra West, Mumbai",
      state: "Mumbai",
      developer: "Rustomjee",
      bed: "4 - 5 BHK Apartments",
      size: "On Request",
      url: `/rustomjee-the-panorama-pali-hill-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Rustomjee - 180 Bayview",
      image: bay180,
      price: "On Request",
      location: "Mumbai",
      projectlocation: "Wellesley Road",
      state: "Mumbai",
      developer: "Rustomjee",
      bed: "2 - 3 - 4 BHK Apartments",
      size: "824 - 1664 sq.ft.",
      url: `/rustomjee-180-bayview-matunga-west-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    // {
    //   name: "Rustomjee - Ocean Vista",
    //   image: "",
    //   price: "On Request",
    //   location: "Mumbai",
    //   projectlocation: "Wellesley Road",
    //   state: "Mumbai",
    //   developer: "Rustomjee",
    //   bed: "1 - 3 BR Apartments",
    //   size: "On Request",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
    // {
    //   name: "Rustomjee - Avenue I",
    //   image: Avenue,
    //   price: "On Request",
    //   location: "Mumbai",
    //   projectlocation: "Wellesley Road",
    //   state: "Mumbai",
    //   developer: "Rustomjee",
    //   bed: "2 BHK Apartments",
    //   size: "510 - 584 sq.ft.",
    //   url: `/developers/birla/birla-estate`,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   },
    // },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1996",
  },
  about: `Rustomjee was established in 1996 with the conviction that concepts serve as the foundation for structures. All that is needed to realize them are bricks and mortar.
The Rustomjee legacy includes two township developments, more than 14,000 contented families, and more than 20 million square feet of supplied space.

Choose from a variety of homes in townships where children can be kids, gated communities where you can follow your passions, and isolated landmarks that draw attention to yourself to choose your ideal home.`,
};
export const projectsrustomjee = {
  rustomjeeparishram: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_parishram,
      bannerMobileImage: bannerMobileImage_parishram,
      textOverlay: "",
      data: {
        title: "Rustomjee Parishram",
        subtitle: "Pali Hill, Mumbai",
        starting_price: "16.8 Cr",
        rerano: "P51800033333",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Rustomjee Parishram – Luxury Living in Pali Hill, Mumbai",
      description: [
        `Discover Rustomjee Parishram, an exclusive luxury residential project by Rustomjee, located in the prestigious Pali Hill, Mumbai. Designed for those who seek sophistication and comfort, this premium development offers an unparalleled living experience in one of Mumbai’s most sought-after neighborhoods.

Nestled in the heart of Pali Hill, one of Mumbai’s most elite and serene localities, Rustomjee Parishram provides a perfect blend of privacy, greenery, and connectivity. This upscale address is home to Bollywood celebrities, business tycoons, and high-net-worth individuals, making it a symbol of prestige and exclusivity.

Crafted with impeccable design and modern architecture, Rustomjee Parishram offers spacious residences with high-end finishes, state-of-the-art amenities, and breathtaking views of the city. Residents can enjoy top-tier facilities, including a well-equipped fitness center, landscaped gardens, a rooftop lounge, swimming pool, and 24/7 security, ensuring a lifestyle of elegance and comfort.`,
      ],
      image: overviewImage_parishram,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_parishram,
          title: "16.8 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_parishram,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_parishram,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_parishram,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1473.59 - 1521.49 sq. ft.",
          price: "16.8 - 17.35 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
          area: "1473.59 - 1521.49 sq. ft.",
          price: "16.8 - 17.35 Cr",
        image: image1BHK_parishram,
      },
      {
        type: "4 BHK",
          area: "On Request",
          price: "On Request",
        image: image2BHK_parishram,
      },
      {
        type: "5 BHK",
          area: "On Request",
          price: "On Request",
        image: image3BHK_parishram,
      },
    ],

    highlights: {
      images: Hightlights_parishram,
      tagline: "Highlights",
      features: [
        "Unbeatable connectivity to Swami Vivekanand Road and Western Express Highway",
        "Luxurious amenities like gymnasium and 24x7 power backup",
        "Well-designed 3, 4, and 5 BHK apartments with perfect blend of space and comfort",
        "Range of unit options from 1474 to 3284 Sq. Ft. for diverse needs",
        "Attention to detail in interior design, with oil-bound distemper walls in bedrooms",
      ],
    },

    location: {
      image: Location_parishram,
      data:[
        {
          airport:{
            distance_time:"5.7 Km",
            name:"CSMI Airport"
          },
          school:{
            distance_time:"2.3 Km",
            name:"RMI School"
          },
          railwayormetro:{
            distance_time:"7.9 Km",
            name:"Gundavali Metro"
          },
          hospital:{
            distance_time:"1.2 Km ",
            name:"Holy Hospital "
          },
          mall:{
            distance_time:"1.9 Km",
            name:"Link Square Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_parishram },
        { image: g2_parishram },
        { image: g3_parishram },
        { image: g4_parishram },
        { image: g5_parishram },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Rustomjee Parishram, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Rustomjee Parishram.`  },
      {
        question: "Who is the developer of Rustomjee Parishram?",
        answer: `The project is developed by Rustomjee.`  },
      {
        question: "Where is Rustomjee Parishram located?",
        answer: `It is located in Pali Hill, Mumbai.`   },
      {
        question: "What types of apartments are available in Rustomjee Parishram?",
        answer: `The project offers 3 BHK, 4 BHK, and 5 BHK apartments.`     },
      {
        question: "What is the size range of the 3 BHK apartments?",
        answer: `The 3 BHK apartments range from 1473.59 to 1521.49 sq. ft.`   },
      {
        question: "What is the price range of the 3 BHK apartments?",
        answer: `The price ranges from ₹16.8 Cr to ₹17.35 Cr.`     },
      {
        question: "Is the area for 4 BHK and 5 BHK apartments available?",
        answer: `No, the area for 4 BHK and 5 BHK apartments is available on request.`  },
      {
        question: "What is the starting price of apartments in Rustomjee Parishram?",
        answer: `The starting price is ₹16.8 Cr.`  },
      {
        question: "What is the current status of Rustomjee Parishram?",
        answer: `The project is under construction.`   },
      {
        question: "Is the project located in a prime area of Mumbai?",
        answer: `Yes, Pali Hill is one of the most premium residential locations in Mumbai.`   },
    ],
    similar: {
      properties: [
        {
          name: "Rustomjee - The Panorama",
          image: panorama,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "Pali Hill, Bandra West, Mumbai",
          state: "Mumbai",
          developer: "Rustomjee",
          bed: "4 - 5 BHK Apartments",
          size: "On Request",
          url: `/rustomjee-the-panorama-pali-hill-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Rustomjee - 180 Bayview",
          image: bay180,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "Wellesley Road",
          state: "Mumbai",
          developer: "Rustomjee",
          bed: "2 - 3 - 4 BHK Apartments",
          size: "824 - 1664 sq.ft.",
          url: `/rustomjee-180-bayview-matunga-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        // {
        //   name: "Rustomjee - Ocean Vista",
        //   image: "",
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "1 - 3 BR Apartments",
        //   size: "On Request",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
        // {
        //   name: "Rustomjee - Avenue I",
        //   image: Avenue,
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "2 BHK Apartments",
        //   size: "510 - 584 sq.ft.",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  thepanorama: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_panorama,
      bannerMobileImage: bannerMobileImage_panorama,
      textOverlay: "",
      data: {
        title: "The Panorama",
        subtitle: "Pali Hill, Mumbai",
        starting_price: "On Request",
        rerano: "P51800054920",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Rustomjee The Panorama: Luxury Homes in Pali Hill, Mumbai",
      description: [
        `Rustomjee The Panorama is an exclusive residential project located in Pali Hill, Mumbai, one of the city's most prestigious and sought-after neighborhoods. Developed by Rustomjee, a leading name in the real estate industry, this project offers a blend of modern architecture, premium amenities, and an elevated living experience.

Pali Hill is known for its serene environment, tree-lined streets, and proximity to major commercial and entertainment hubs. The Panorama is designed to provide spacious and well-ventilated homes with panoramic views of the city and the Arabian Sea. The residences feature high-quality finishes, contemporary interiors, and large windows to enhance natural light and airflow.

The project includes a range of luxury amenities, such as a rooftop infinity pool, landscaped gardens, a fitness center, and dedicated spaces for recreation and relaxation. Its strategic location ensures excellent connectivity to business districts, educational institutions, healthcare facilities, and lifestyle destinations.

With a reputation for quality and innovation, Rustomjee has developed The Panorama to meet the needs of modern urban dwellers seeking a balance between convenience and exclusivity. This development stands as a testament to sophisticated living in one of Mumbai’s prime residential areas.`,
      ],
      image: overviewImage_panorama,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_panorama,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_panorama,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_panorama,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_panorama,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "2542 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "2542 sq. ft.",
        price: "On Request",
        image: image1BHK_panorama,
      },

     
    ],

    highlights: {
      images: Hightlights_panorama,
      tagline: "Highlights",
      features: [
        "Exclusive Low-Density Design",
        "Dedicated EV Charging Stations",
        "RERA-Approved Development",
        "Unobstructed Panoramic Views",
        "Vastu-Compliant Residences",
      ],
    },

    location: {
      image: Location_panorama,
      data:[
        {
          airport:{
            distance_time:"12.9 Km ",
            name:"CSMI Airport"
          },
          school:{
            distance_time:"2 Km ",
            name:"St. Andrew's School"
          },
          railwayormetro:{
            distance_time:"1 Km",
            name:"Rizvi Metro Station"
          },
          hospital:{
            distance_time:"2 Km ",
            name:" Holy Hospital"
          },
          mall:{
            distance_time:"760 m",
            name:"Link Square Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_panorama },
        { image: g2_panorama },
        { image: g3_panorama },
        { image: g4_panorama },
        { image: g5_panorama },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Rustomjee The Panorama, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The name of the project is The Panorama.`    },
      {
        question: "Who is the developer of The Panorama?",
        answer: `The developer of The Panorama is Rustomjee.`   },
      {
        question: "Where is The Panorama located?",
        answer: `The Panorama is located in Pali Hill, Mumbai.`   },
      {
        question: "What type of apartments are available in The Panorama?",
        answer: `The project offers 4 BHK apartments.`   },
      {
        question: "What is the area of the 4 BHK apartments in The Panorama?",
        answer: `The area of the 4 BHK apartments is 2,542 sq. ft.`  },
      {
        question: "What is the price of the apartments in The Panorama?",
        answer: `The price is available on request.`    },
      {
        question: "What is the starting price of the apartments?",
        answer: `The starting price is also available on request.`   },
      {
        question: "Which city is The Panorama located in?",
        answer: `It is located in Mumbai.`  },
      {
        question: "Who is the builder of The Panorama?",
        answer: `Rustomjee is the builder of this project.`   },
      {
        question: "Does The Panorama offer any smaller configurations like 2 BHK or 3 BHK?",
        answer: `No, The Panorama offers only 4 BHK apartments.`  },
    ],
    similar: {
      properties: [
        {
          name: "Rustomjee - Parishram ",
          image: Parishram,
          price: "On Request",
          location: "Pali Hill, Bandra, Mumbai",
          bed: "1 - 3 BHK",
          state: "Mumbai",
          developer: "Rustomjee",
          size: "1564 Sq. Ft. ",
          url: `/rustomjee-parishram-pali-hill-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

        {
          name: "Rustomjee - 180 Bayview",
          image: bay180,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "Wellesley Road",
          state: "Mumbai",
          developer: "Rustomjee",
          bed: "2 - 3 - 4 BHK Apartments",
          size: "824 - 1664 sq.ft.",
          url: `/rustomjee-180-bayview-matunga-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        // {
        //   name: "Rustomjee - Ocean Vista",
        //   image: "",
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "1 - 3 BR Apartments",
        //   size: "On Request",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
        // {
        //   name: "Rustomjee - Avenue I",
        //   image: Avenue,
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "2 BHK Apartments",
        //   size: "510 - 584 sq.ft.",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
  rustomjeebayview: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_180bayview,
      bannerMobileImage: bannerMobileImage_180bayview,
      textOverlay: "",
      data: {
        title: "180 Bayview",
        subtitle: "Matunga West, Mumbai",
        starting_price: "4.15 Cr",
        rerano: "P51900066547",
        payment_plan: "CLP",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Rustomjee 180 Bayview - Luxury Homes in Matunga West, Mumbai",
      description: [
        `Discover Rustomjee 180 Bayview, an exclusive residential project in Matunga West, Mumbai, by the renowned developer Rustomjee. This premium development offers a perfect blend of modern design, world-class amenities, and breathtaking sea views, making it an ideal choice for those seeking luxury and convenience.

Strategically located in Matunga West, one of Mumbai’s most sought-after neighborhoods, Rustomjee 180 Bayview provides seamless connectivity to key business hubs, educational institutions, healthcare centers, and entertainment zones. The project boasts well-designed residences with spacious layouts, high-end fittings, and panoramic views of the Arabian Sea, ensuring a sophisticated urban lifestyle.

Residents can enjoy a range of top-notch amenities, including a state-of-the-art gym, landscaped gardens, a rooftop lounge, swimming pool, kids’ play area, and multipurpose hall. The project is designed to offer a serene escape from the city’s hustle while keeping you close to everything you need.

With Rustomjee’s legacy of delivering exceptional real estate projects, 180 Bayview stands as a testament to excellence in construction, innovation, and customer satisfaction. Whether you're looking for a dream home or a smart investment, this project promises unparalleled value.`,
      ],
      image: overviewImage_180bayview,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_180bayview,
          title: "4.15 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_180bayview,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_180bayview,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_180bayview,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "824 - 834 sq. ft.",
          price: "4.15 - 4.17 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1221.18 - 1337.43 sq. ft.",
          price: "5.5 - 5.69 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1663.58 sq. ft.",
          price: "7.42 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
          area: "824 - 834 sq. ft.",
          price: "4.15 - 4.17 Cr",
        image: image1BHK_180bayview,
      },

      {
        type: "3 BHK",
          area: "1221.18 - 1337.43 sq. ft.",
          price: "5.5 - 5.69 Cr",
        image: image2BHK_180bayview,
      },
      {
        type: "4 BHK",
          area: "1663.58 sq. ft.",
          price: "7.42 Cr",
        image: image3BHK_180bayview,
      },
    ],

    highlights: {
      images: Hightlights_180bayview,
      tagline: "Highlights",
      features: [
        "180-degree sea view",
        "Rooftop amenities include an open-to-sky swimming pool",
        "Lifestyle amenities are spread across three levels",
        "State of the art fitness center",
        "Fountain pond, spillover lawn, cascading pond, and many more",
      ],
    },

    location: {
      image: Location_180bayview,
      data:[
        {
          airport:{
            distance_time:"10 km",
            name:"CSMI Airport"
          },
          school:{
            distance_time:"850 m",
            name:"Scottish School"
          },
          railwayormetro:{
            distance_time:"600 m",
            name:"Matunga Railway Station"
          },
          hospital:{
            distance_time:"750 m",
            name:" Hinduja Hospital"
          },
          mall:{
            distance_time:"6.7 Km",
            name:"Phoenix Palladium"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_180bayview },
        { image: g2_180bayview },
        { image: g3_180bayview },
        { image: g4_180bayview },
        { image: g5_180bayview },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Rustomjee 180 Bayview, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Rustomjee 180 Bayview.`  },
      {
        question: "Who is the developer of Rustomjee 180 Bayview?",
        answer: `The developer is Rustomjee.`  },
      {
        question: "Where is Rustomjee 180 Bayview located?",
        answer: `It is located in Matunga West, Mumbai.` },
      {
        question: "What is the starting price of apartments in this project?",
        answer: `The starting price is ₹4.15 Cr.`  },
      {
        question: "What types of apartments are available in this project?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK apartments.`   },
      {
        question: "What is the area range for 2 BHK apartments?",
        answer: `The area ranges from 824 to 834 sq. ft.`    },
      {
        question: "What is the price range for 2 BHK apartments?",
        answer: `The price ranges from ₹4.15 Cr to ₹4.17 Cr.`  },
      {
        question: "What is the area range for 3 BHK apartments?",
        answer: `The area ranges from 1221.18 to 1337.43 sq. ft.`   },
      {
        question: "What is the price range for 3 BHK apartments?",
        answer: `The price ranges from ₹5.5 Cr to ₹5.69 Cr.
`  },
      {
        question: "What is the area of 4 BHK apartments?",
        answer: `The area is 1663.58 sq. ft.`   },
    ],
    similar: {
      properties: [
        {
          name: "Rustomjee - Parishram ",
          image: Parishram,
          price: "On Request",
          location: "Pali Hill, Bandra, Mumbai",
          bed: "1 - 3 BHK",
          state: "Mumbai",
          developer: "Rustomjee",
          size: "1564 Sq. Ft. ",
          url: `/rustomjee-parishram-pali-hill-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Rustomjee - The Panorama",
          image: panorama,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "Pali Hill, Bandra West, Mumbai",
          state: "Mumbai",
          developer: "Rustomjee",
          bed: "4 - 5 BHK Apartments",
          size: "On Request",
          url: `/rustomjee-the-panorama-pali-hill-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

        // {
        //   name: "Rustomjee - Ocean Vista",
        //   image: "",
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "1 - 3 BR Apartments",
        //   size: "On Request",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
        // {
        //   name: "Rustomjee - Avenue I",
        //   image: Avenue,
        //   price: "On Request",
        //   location: "Mumbai",
        //   projectlocation: "Wellesley Road",
        //   state: "Mumbai",
        //   developer: "Rustomjee",
        //   bed: "2 BHK Apartments",
        //   size: "510 - 584 sq.ft.",
        //   url: `/developers/birla/birla-estate`,
        //   form: {
        //     source_id: 11,
        //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        //     sub_source_id: 130,
        //     builder_id: `103`,
        //     project_id: `477`,
        //     subject: "M3M Altitude", // Add or update the subject here
        //     to_email: "jatin.rohilla@propertystation.in",
        //   },
        // },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
